export default __webpack_public_path__ + "d7fa933aadd2d3e64d5b78e62282bc6e.png";